import React from 'react';

const TrashIcon = () => (
  <svg className="icon icon-trash" width="12px" height="16px" viewBox="0 0 12 16">
    <g id="Blinds.com" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Assets" className="Assets" transform="translate(-65.000000, -233.000000)" fill="#009FD4">
        <g id="trash" className="trash" transform="translate(64.000000, 233.000000)">
          <path id="Rectangle-18" className="Rectangle-18" d="M2,4 L12,4 L12,14 C12,15.1045695 11.1045695,16 10,16 L4,16 C2.8954305,16 2,15.1045695 2,14 L2,4 Z" />
          <polygon id="Path-13" className="Path-13" points="0.965026855 1.01741073 0.965026855 3.00133023 12.9697654 3.00133023 12.9697654 1.01741073 9.96726385 1.01741073 9.04694389 0.097090775 5.02917975 0.097090775 4.12145451 1.00481601" />
        </g>
      </g>
    </g>
  </svg>
);

export default TrashIcon;
